import { ActionReducerMap, combineReducers, Action } from '@ngrx/store';
import { TransaccionesState } from '../models/store.model';

import * as fromPrestacion from './prestacion.reducer';
import * as fromPrescriptor from './prescriptor.reducer';
import * as fromEfector from './efector.reducer';
import * as fromDiagnostico from './diagnostico.reducer';
import * as fromAtencion from './atencion.reducer';
import * as fromAcompanante from './acompanante.reducer';
import * as fromDerivacion from './derivacion.reducer';
import * as fromReadonly from './readonly.reducer';
import * as fromReceta from './receta.reducer';

export const transaccionesReducersMap: ActionReducerMap<TransaccionesState> = {
    prestacionData: fromPrestacion.prestacionDataReducer,
    prescriptorData: fromPrescriptor.prescriptorDataReducer,
    efectorData: fromEfector.efectorDataReducer,
    diagnosticoData: fromDiagnostico.diagnosticoDataReducer,
    atencionData: fromAtencion.atencionDataReducer,
    acompananteData: fromAcompanante.acompananteDataReducer,
    derivacionData: fromDerivacion.derivacionDataReducer,
    isReadonly: fromReadonly.readonlyReducer,
    recetaRequest: fromReceta.recetaDataReducer,
};

import { CLEAR_TRANSACCIONES_DATA } from '../actions/transacciones.action';

export function transaccionesReducer(state: TransaccionesState | undefined, action: Action) {
    if (action.type === CLEAR_TRANSACCIONES_DATA) {
        state = undefined;
    }
    return combineReducers(transaccionesReducersMap)(state, action);
}
